import { render, staticRenderFns } from "./type-expand.vue?vue&type=template&id=45079a54&scoped=true&"
import script from "./type-expand.vue?vue&type=script&lang=js&"
export * from "./type-expand.vue?vue&type=script&lang=js&"
import style0 from "./type-expand.vue?vue&type=style&index=0&id=45079a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45079a54",
  null
  
)

export default component.exports